import script from "./PreviewSMSDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewSMSDialog.vue?vue&type=script&setup=true&lang=js"

import "./PreviewSMSDialog.vue?vue&type=style&index=0&id=2d1206c9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1206c9"]])

export default __exports__